import { MdExpandMore, MdChevronRight } from 'react-icons/md';
import DataItem from 'components/DataItem';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

const labelStyle = 'text-[16px] text-gray-500 font-medium mb-[9px]';

export default function FlightsItem({
  isOutbound,
  travelTime = '',
  departureAirportCode = '',
  departureAirportName = '',
  arrivalAirportCode = '',
  arrivalAirportName = '',
  departureTime = '',
  departureDate = '',
  arrivalTime = '',
  arrivalDate = '',
  flightNumber = '',
  // checkInDate = '',
  arrivalTerminal = '',
  departureTerminal = '',
  airline = '',
}) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();

  const backgroundStyle = {
    backgroundColor: primaryColour || DEFAULT_PRIMARY_COLOUR,
  };

  return (
    <>
      <div
        style={backgroundStyle}
        className="mt-[40px] rounded-t-lg text-white text-xl font-bold"
      >
        <div className="p-4 text-[24px] font-medium">
          <div>{isOutbound ? 'Outbound' : 'Inbound'}</div>
        </div>
      </div>
      <div className="bg-white px-[15px]">
        <div className="flex flex-col border-b border-dashed pb-2 md:flex-row md:p-4 md:w-full mb-[24px]">
          <div className="my-3 flex flex-col justify-between text-center md:text-left">
            <div className={labelStyle}>Departure point</div>
            <div
              className="font-medium text-[22px]"
              style={{ color: primaryColour }}
            >
              {departureAirportCode}
            </div>
            <div className={labelStyle}>{departureAirportName}</div>
          </div>
          <div className="md:grow md:flex md:flex-col md:justify-content md:mt-6">
            <div className="flex justify-center ">
              <div className="w-[45%] border-b border-gray-400 mb-3 ml-4">
                {' '}
              </div>
              <div>
                <div
                  style={backgroundStyle}
                  className="p-1 mx-2 text-white rounded-full"
                >
                  <div className="lg:hidden">
                    <MdExpandMore />
                  </div>
                  <div className="hidden lg:block">
                    <div className="text-[22px]">
                      <MdChevronRight />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-[45%] border-b border-gray-400 mb-3 mr-4">
                {' '}
              </div>
            </div>
            <div className="text-center my-1 text-[14px] hidden">
              {travelTime}
            </div>
          </div>
          <div className="my-3 flex flex-col justify-between text-center md:text-right">
            <div className={labelStyle}>Arrival point</div>
            <div
              className="font-medium text-[22px]"
              style={{ color: primaryColour }}
            >
              {arrivalAirportCode}
            </div>
            <div className={labelStyle}>{arrivalAirportName}</div>
          </div>
        </div>
        <div className="mb-7 bg-white">
          <div className="flex flex-wrap pb-3 mx-0 md:mx-4">
            {departureDate && (
              <DataItem label="Departure date" value={departureDate} isSmall />
            )}
            {departureTime && (
              <DataItem label="Departure time" value={departureTime} isSmall />
            )}
            {departureTerminal && (
              <DataItem
                label="Departure Terminal"
                value={departureTerminal}
                isSmall
              />
            )}
            {/* {checkInDate && (
              <DataItem label="Check In Date" value={checkInDate} isSmall />
            )} */}
            <div className="flex nowrap w-full">
              {arrivalDate && (
                <DataItem label="Arrival date" value={arrivalDate} isSmall />
              )}
              {arrivalTime && (
                <DataItem label="Arrival time" value={arrivalTime} isSmall />
              )}
            </div>
            {arrivalTerminal && (
              <DataItem
                label="Arrival Terminal"
                value={arrivalTerminal}
                isSmall
              />
            )}
            {flightNumber && (
              <DataItem label="Flight number" value={flightNumber} isSmall />
            )}
            {airline && <DataItem label="Airline" value={airline} isSmall />}
          </div>
        </div>
      </div>
    </>
  );
}
